var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlagGray(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3307 4.70604L11.4977 8.17151L13.3286 11.5581C13.4143 11.7179 13.4116 11.9108 13.3196 12.0678C13.2276 12.2241 13.061 12.3209 12.8792 12.3237L3.6631 12.4475V4.46399C3.6631 4.17754 3.43094 3.94531 3.14453 3.94531H12.8723C13.0541 3.94531 13.2228 4.04006 13.3168 4.19635C13.4109 4.35265 13.4157 4.5456 13.3307 4.70604Z",
    fill: "#D5D5D5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.9564 3.94336C3.26672 3.94336 3.51828 4.11753 3.51828 4.33237V13.6686C3.51828 13.8834 3.26672 14.0576 2.9564 14.0576C2.64609 14.0576 2.39453 13.8834 2.39453 13.6686V4.33237C2.39453 4.11753 2.64609 3.94336 2.9564 3.94336Z",
    fill: "#484848"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagGray);
export default __webpack_public_path__ + "static/media/flag_gray.57e55b672907c1cc86b4881e694af6b0.svg";
export { ForwardRef as ReactComponent };